import map from 'lodash/map'

const initialRawMaterialsOptions = agriculturalInputs =>
  map(agriculturalInputs, rawMaterial => ({
    label: rawMaterial.agriculturalInputStockName,
    value: rawMaterial.agriculturalInputStockId.toString()
  }))

const initialMachinesOptions = machines =>
  map(machines, machine => ({
    label: machine.name,
    value: machine.id.toString()
  }))

const initialResponsibleOptions = ({
  userResponsiblePlanned,
  userResponsibleIdPlanned,
  userResponsibleRealized,
  userResponsibleIdRealized
}) => {
  if (userResponsibleRealized && userResponsibleIdRealized) {
    return [{
      label: userResponsibleRealized,
      value: userResponsibleIdRealized.toString()
    }]
  }

  if (userResponsiblePlanned && userResponsibleIdPlanned) {
    return [{
      label: userResponsiblePlanned,
      value: userResponsibleIdPlanned.toString()
    }]
  }

  return []
}

export {
  initialMachinesOptions,
  initialRawMaterialsOptions,
  initialResponsibleOptions
}
